import { render, staticRenderFns } from "./confLists.vue?vue&type=template&id=6a19a809&scoped=true&"
import script from "./confLists.vue?vue&type=script&lang=js&"
export * from "./confLists.vue?vue&type=script&lang=js&"
import style0 from "./confLists.vue?vue&type=style&index=0&id=6a19a809&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a19a809",
  null
  
)

export default component.exports